import { render, staticRenderFns } from "./FAQShow.vue?vue&type=template&id=0dc76f44&"
import script from "./FAQShow.vue?vue&type=script&lang=ts&"
export * from "./FAQShow.vue?vue&type=script&lang=ts&"
import style0 from "./FAQShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports